"use client";

export { GlobalError as default } from "@dealerzone/libs/sentry/client";
